import { useEffect } from 'react';

export default function useServiceReveal(ref, identity) {
  useEffect(() => {
    const root = ref.current;
    if (!root || !window.IntersectionObserver) return;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motion.matches) return;
    const blocks = root.querySelectorAll('.service-detail-page__intro, .service-detail-page__section, .health-sub__intro, .health-sub__section');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('service-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    blocks.forEach(block => { block.classList.add('service-reveal'); observer.observe(block); });
    const showAll = () => {
      if (motion.matches) blocks.forEach(block => block.classList.add('service-reveal--visible'));
    };
    motion.addEventListener('change', showAll);
    return () => {
      observer.disconnect(); motion.removeEventListener('change', showAll);
      blocks.forEach(block => block.classList.remove('service-reveal', 'service-reveal--visible'));
    };
  }, [ref, identity]);
}
